import { getEnv } from '@luna/env';
import { logger } from '@luna/logger';
import { getFeatureConfig } from '@luna/feature-config';

import { getCurrentApiTarget } from './EnvironmentService';
import { areDevToolsEnabled } from './DevToolsService';

export const API_TARGET_URL_PARAM = 'apiTarget';

const updateUrlApiTarget = (
    url: string,
    currentApiTargets: string[],
    newApiTargets: string[],
): string => {
    return currentApiTargets.reduce((value, currentApiTarget, index) => {
        const newApiTarget = newApiTargets[index];
        if (!newApiTarget) {
            return value;
        }

        return value.replace(currentApiTarget, newApiTarget);
    }, url);
};

export function overrideApiTargetFromUrl(): void {
    const searchParams = new URLSearchParams(window.location.search);
    const newApiTarget = searchParams.get(API_TARGET_URL_PARAM);
    const currentApiTarget = getCurrentApiTarget();

    if (!newApiTarget || !currentApiTarget) {
        return;
    }

    if (!areDevToolsEnabled()) {
        return;
    }

    const { availableApiTargets } = getFeatureConfig(({ devTools }) => devTools);

    // For backwards compatibility with older FE versions
    // which used different available targets map with different keys
    // Can be removed in time
    const legacyAvailableApiTargets = Object.entries(availableApiTargets).reduce<
        Record<string, string[]>
    >(
        (normalizedMap, [name, origin]) => ({
            ...normalizedMap,
            [name.toLowerCase().replaceAll(' ', '')]: origin,
        }),
        {},
    );

    const newApiTargets = legacyAvailableApiTargets[newApiTarget];
    const currentApiTargets = availableApiTargets[currentApiTarget];

    if (!newApiTargets || !currentApiTargets) {
        logger.warn('Invalid api target params. No switch will be done.', {
            currentApiTargetOrigin: currentApiTargets,
            newApiTargetOrigin: newApiTargets,
        });
        return;
    }

    const environmentConfig = getEnv<Record<string, unknown>>();

    Object.entries(environmentConfig).forEach(([key, value]) => {
        if (typeof value !== 'string') {
            return;
        }

        environmentConfig[key] = updateUrlApiTarget(value, currentApiTargets, newApiTargets);
    });
}
